import { saveAs } from "file-saver";

export function drawSnapshot(video, canvas) {
  const width = video.videoWidth;
  const height = video.videoHeight;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(video, 0, 0, width, height);
}

export function getCanvasImage(canvas) {
  return canvas.toDataURL("image/png");
}

export async function copyImageToClipboard(image) {
  const resp = await fetch(image);
  const blob = await resp.blob();
  await navigator.clipboard.write([new ClipboardItem({ "image/png": blob })]);
}

export async function downloadCanvasImage(canvas, filename) {
  canvas.toBlob(blob => saveAs(blob, filename));
}
